import axios from 'axios';
import { getToken, clearToken } from '../utils/tokenStorage';

const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:5050/api';

const isInsecureHttpUrl = (urlValue) => {
  if (!urlValue || typeof urlValue !== 'string') return false;
  if (!urlValue.startsWith('http://')) return false;
  return !(urlValue.includes('localhost') || urlValue.includes('127.0.0.1'));
};

if (process.env.NODE_ENV === 'production' && isInsecureHttpUrl(baseURL)) {
  throw new Error('Insecure REACT_APP_API_URL (http://) in production build. Use https://');
}

const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests if exists
const token = getToken();
if (token) {
  api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

// Response interceptor for error handling.
// Guard: do NOT redirect on 401 from the login endpoint itself — the login page
// handles that inline. All other 401s (expired/revoked session) redirect as before.
const LOGIN_ENDPOINT = '/auth/login/admin';

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const requestUrl = error.config?.url || '';
    const isLoginRequest = requestUrl.includes(LOGIN_ENDPOINT);
    if (error.response?.status === 401 && !isLoginRequest) {
      clearToken();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
